import React from "react";
import { Report } from "../../DataTypes";

interface FileDownloaderProps {
  label?: string;
  report: Report;
  companyId?: number;
  downloadHandler: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    report: Report,
    companyId?: number
  ) => void;
}

const FileDownloader = ({
  label = "Download opt-ins",
  report,
  companyId,
  downloadHandler,
}: FileDownloaderProps): JSX.Element => (
  <button
    className="black-link"
    onClick={(event) => downloadHandler(event, report, companyId)}
  >
    {label}
  </button>
);

export default FileDownloader;
